import MeasureDataHvidovre from "../data/measure-data.hvidovre.json";
import MeasureDataFvstDiet from "../data/measure-data.fvst.diet.json";
import MeasureDataFvstMunicipality from "../data/measure-data.fvst.municipality.json";

export function getMockMeasurementData(mockMeasureDataFile:string) : any {
	switch (mockMeasureDataFile) {
		case 'hvidovre':
			console.log('Loading mock data for Hvidovre');

			return MeasureDataHvidovre;
		case 'fvst.diet':
			console.log('Loading mock data for FVST diet variation');

			return MeasureDataFvstDiet;
		case 'fvst.municipality':
			console.log('Loading mock data for FVST municipality variation');

			return MeasureDataFvstMunicipality;
		default:
			throw new Error(`Unknown mock measure data file ${mockMeasureDataFile}`);
	}
}

export function attemptLoadMockData() : void {
	if (!process.env.VUE_APP_MOCK_MEASURE_DATA_FILE) {
		return; // Not available
	}

	//@ts-ignore
	if (window.measurementData) {
		return; // Already loaded
	}

	const mockMeasurementData:any = getMockMeasurementData(process.env.VUE_APP_MOCK_MEASURE_DATA_FILE);

	console.log('mockMeasurementData', process.env.VUE_APP_MOCK_MEASURE_DATA_FILE, mockMeasurementData);

	//@ts-ignore
	window.measurementData = mockMeasurementData;
}

console.log('MOCK DATA');
